import { AxiosError } from 'axios';
import CookieApi from './CookieApi';

interface EventData {
  event: string;
  eventCategory: string;
  eventAction?: string;
  eventLabel?: string;
}

const ErrorUtil = {
  pushError(pageError: boolean, error: Error, message?: string): string {
    const otelReference = this.pushErrorToTeliaRumAndGetTransaction(error, message);
    this.pushErrorToDataLayer(pageError, otelReference);
    return otelReference;
  },

  pushErrorToTeliaRumAndLog(error: Error, message?: string): void {
    this.supplementErrorStack(error);
    if (window.TeliaRum) {
      window.TeliaRum.sendError(error, message);
    }
    console.error(error);
  },

  getTeliaRumUserTrackerCookie(): string {
    return CookieApi.getCookieValue('rum_session_id');
  },

  pushErrorToTeliaRumAndGetTransaction(error: Error, message?: string): string {
    const otelReference: string = this.pushErrorToTeliaRum(error, message);
    return `tx:${otelReference}:ut:${this.getTeliaRumUserTrackerCookie()}`;
  },

  pushErrorToTeliaRum(error: Error, message?: string): string {
    if (window.TeliaRum) {
      this.supplementErrorStack(error);
      return window.TeliaRum.sendError(error, message);
    }
  },

  dispatchErrorEvent(error: Error): void {
    window.dispatchEvent(new ErrorEvent('error', error));
  },

  pushErrorToDataLayer(pageError: boolean, otelReference: string): void {
    const eventData: EventData = {
      event: 'NONIEvent',
      eventCategory: 'Error'
    };

    if (window.dataLayer) {
      eventData.eventAction = pageError ? 'Page error' : 'Component error';
      eventData.eventLabel = otelReference;
      window.dataLayer.push(eventData);
    }
  },

  supplementErrorStack(error: Error | string) {
    if ((error as AxiosError)?.config) {
      const e = error as AxiosError;
      (error as AxiosError).stack = `${e?.message}, ${e?.config?.method}:${e?.config?.url} \n ${e.stack}`;
    }
  }
};

export default ErrorUtil;
